module.exports = __webpack_public_path__ + "img/op_como-funciona-relink-3.a70ce1b.png";